import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Synonym, SynonymCreate } from "@/model";
import SynonymRepository from "@/repository/synonymRepository";
import { synonymQueryKeys } from "./keys";


export const useCreateSynonym = (agentId: number) => {
    const queryClient = useQueryClient();

    return useMutation<Synonym, AxiosError, SynonymCreate>({
        mutationKey: ["synonym", "agent", agentId, "create"],
        mutationFn: async (synonymCreate) => {
            const res = await SynonymRepository.create(agentId, synonymCreate);
            return res.data.data;
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: synonymQueryKeys.all(agentId) });
        }
    });
};